import {View, TouchableOpacity} from 'react-native';
import React from 'react';
import {BankAccount} from 'StoreInfo';
import SkillzSVG from 'SkillzSVG';
import {styles} from './BankAccountSelectionStyles';
import {_m} from 'INTL';
import Label from 'Label';

type BankAccountSelectionProps = {
  bankAccounts: BankAccount[];
  selectedBankAccount?: BankAccount | null;
  onSelect: () => void;
};

const BankAccountSelection = ({
  bankAccounts,
  selectedBankAccount,
  onSelect,
}: BankAccountSelectionProps) => {
  const defaultBankAccount =
    (bankAccounts.find((bank) => bank.is_selected) as BankAccount) || bankAccounts[0];

  return (
    <TouchableOpacity onPress={() => onSelect()} style={styles.container}>
      <Label style={styles.selectedBankAccountText}>
        {selectedBankAccount ? selectedBankAccount.name : defaultBankAccount.name}
      </Label>
      <View>
        <SkillzSVG
          source={'icon_down_arrow.svg'}
          style={styles.downArrowIcon}
          tintColor='#367BCE'
        />
      </View>
    </TouchableOpacity>
  );
};

export default BankAccountSelection;
